import { axiosPost } from "../axios/config";

export const askQuestion = async (question, dashboardId) => {
	const response = await axiosPost(`/api/v2/galactus/ask`, { question, dashboardId });
	return response;
};
